import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PartnerRegionalMultiplierListType } from "./Types";
import { updatePartnerRegionalMultiplierDetailsType } from "../../../saga/partner-program/regional-multipliers/saga-actions";

type initialStateType = {
    fetchedPartnerRegionalMultiplierID: number;
    partnerRegionalMultiplierList: PartnerRegionalMultiplierListType;
    status: {
        partnerRegionalListLoading: boolean;
        addpartnerRegionalListStatus: boolean;
        addpartnerRegionalListMessage: string;
        addpartnerRegionalListLoading: boolean;
        updatepartnerRegionalListStatus: boolean;
        updatepartnerRegionalListMessage: boolean,
        updatepartnerRegionalListLoading: boolean,
        deletepartnerRegionalListStatus: boolean;
        deletepartnerRegionalListMessage: boolean;
        deletepartnerRegionalListLoading: boolean;
    }
}

var initialState: initialStateType = {
    fetchedPartnerRegionalMultiplierID: 0,
    partnerRegionalMultiplierList: [],
    status: {
        partnerRegionalListLoading: false,
        addpartnerRegionalListStatus: false,
        addpartnerRegionalListMessage: "",
        addpartnerRegionalListLoading: false,
        updatepartnerRegionalListStatus: false,
        updatepartnerRegionalListMessage: false,
        updatepartnerRegionalListLoading: false,
        deletepartnerRegionalListStatus: false,
        deletepartnerRegionalListMessage: false,
        deletepartnerRegionalListLoading: false,
    }
}

const partnerRegionalMultiplierSlice = createSlice({
    name: "partner_regionalmultiplier",
    initialState: initialState,
    reducers: {
        setFetchedPartnerRegionalMultiplierID: (state, action) => {
            state.fetchedPartnerRegionalMultiplierID = action.payload;
        },
        setPartnerRegionalListLoading: (state, action) => {
            state.status.partnerRegionalListLoading = action.payload;
        },
        setPartnerRegionalMultiplierList: (state, action:PayloadAction<PartnerRegionalMultiplierListType>) => {
            state.partnerRegionalMultiplierList = action.payload;
        },
        setAddpartnerRegionalListStatus: (state, action) => {
            state.status.addpartnerRegionalListStatus = action.payload;
        },
        setAddpartnerRegionalListMessage: (state, action) => {
            state.status.addpartnerRegionalListMessage = action.payload;
        },
        setAddpartnerRegionalListLoading : (state, action) => {
            state.status.addpartnerRegionalListLoading = action.payload;
        },
        setupdatepartnerRegionalListStatus: (state, action) => {
            state.status.updatepartnerRegionalListStatus = action.payload;
        },
        setUpdatepartnerRegionalListMessage: (state, action) => {
            state.status.updatepartnerRegionalListMessage = action.payload;
        },
        setUpdatepartnerRegionalListLoading: (state, action) => {
            state.status.updatepartnerRegionalListLoading = action.payload;
        },
         setUpdatePartnerRegionalMultiplierListUpdate: (
              state,
              action: PayloadAction<updatePartnerRegionalMultiplierDetailsType>
            ) => {
              const updated = action.payload;
              const idx = state.partnerRegionalMultiplierList.findIndex((t) => t.ID === updated.ID);
              if (idx !== -1) {
                state.partnerRegionalMultiplierList[idx] = {
                  ...state.partnerRegionalMultiplierList[idx],
                  country: updated.country,
                  value: Number(updated.value),
                  region: updated.region,
                  region_code: updated.region_code,
                };
              }
            },
        setDeletePartnerRegionalMultiplierStatus: (state, action) => {
            state.status.deletepartnerRegionalListStatus = action.payload;
        },
        setDeletePartnerRegionalMultiplierMessage: (state, action) => {
            state.status.deletepartnerRegionalListMessage = action.payload;
        },
        setDeletePartnerRegionalMultiplierLoading: (state, action) => {
            state.status.deletepartnerRegionalListLoading = action.payload;
        },
    }
})

export const partnerRegionalMultiplierSliceReducer = partnerRegionalMultiplierSlice.reducer;
export const partnerRegionalMultiplierSliceAction = partnerRegionalMultiplierSlice.actions;